<template>
  <div>
    <a-drawer
      title=""
      :width="480"
      placement="right"
      @close="onClose"
      :visible="visible"
    >
      <base-alert v-if="errors.length" type="danger">
        <b>You have the following error(s):</b>
        <li v-for="error in errors" :key="error">{{ error }}</li>
      </base-alert>

      <div v-if="formId == 'addCategory'">
        <h6 class="heading-small text-muted mb-4">Add Sub-Category</h6>
        <form id="form-proper">
          <a-tabs defaultActiveKey="1">
            <a-tab-pane tab="Basic" key="1">
              <!-- {{categoryName}} -->
              <base-input
                alternative=""
                label="Name"
                placeholder=""
                v-model="categoryName"
                input-classes="form-control"
              />
              <!-- {{categoryCode}} -->
              <base-input
                alternative=""
                label="Code"
                placeholder=""
                v-model="categoryCode"
                input-classes="form-control"
              />
              <base-input
                alternative=""
                label="Reference Code"
                placeholder=""
                v-model="categoryRefCode"
                input-classes="form-control"
              />
              <base-input alternative="" label="Remark">
                <textarea
                  v-model="categoryRemark"
                  rows="4"
                  class="form-control"
                />
              </base-input>
            </a-tab-pane>
            <a-tab-pane
              v-if="categoryLevel == 4"
              tab="Category Settings"
              key="2"
            >
              <dynamic-form
                :convertedJson="convertedJson"
                @valueUpdated="updateSettings"
              ></dynamic-form>
            </a-tab-pane>
          </a-tabs>

          <div
            class="float-right"
            style="position: absolute; bottom: 20px; right: 20px;"
          >
            <button class="btn btn-success" @click.prevent="createData">
              Create
            </button>
            <button class="btn" @click.prevent="onClose">Cancel</button>
          </div>
        </form>
      </div>

      <div v-if="formId == 'editCategory'">
        <h6 class="heading-small text-muted mb-4">Edit Category</h6>
        <form id="form-proper">
          <a-tabs defaultActiveKey="1">
            <a-tab-pane tab="Basic" key="1">
              <base-input
                alternative=""
                label="Name"
                placeholder=""
                v-model="categoryName"
                input-classes="form-control"
              />
              <base-input
                alternative=""
                label="Code"
                placeholder=""
                v-model="categoryCode"
                input-classes="form-control"
              />
              <base-input
                alternative=""
                label="Reference Code"
                placeholder=""
                v-model="categoryRefCode"
                input-classes="form-control"
              />
              <base-input alternative="" label="Remark">
                <textarea
                  v-model="categoryRemark"
                  rows="4"
                  class="form-control"
                />
              </base-input>
            </a-tab-pane>

            <a-tab-pane
              v-if="categoryLevel == 4"
              tab="Category Settings"
              key="2"
            >
              <dynamic-form
                :key="componentKey"
                :convertedJson="convertedJson"
                :formSettings="formSettings"
                @valueUpdated="updateSettings"
              ></dynamic-form>
            </a-tab-pane>
          </a-tabs>

          <div
            v-if="serverType == 'ho'"
            class="float-right"
            style="position: absolute; bottom: 20px; right: 20px;"
          >
            <button class="btn btn-success" @click.prevent="updateData">
              Update
            </button>
            <button class="btn" @click.prevent="onClose">Cancel</button>
          </div>

          <div
            v-else
            class="float-right"
            style="position: absolute; bottom: 20px; right: 20px;"
          >
            <button class="btn" @click.prevent="onClose">Cancel</button>
          </div>
        </form>
      </div>
    </a-drawer>

    <base-header type="instore" class="pb-6 pb-8 pt-5 pt-md-8">
      <base-dropdown v-if="activeModules.length > 0">
        <base-button slot="title" type="success" class="dropdown-toggle">
          {{ _.startCase(currentProfile) }}
        </base-button>
        <a
          v-for="profile in activeModules"
          :key="profile.id"
          @click.prevent="
            setCurrentProfile(
              _.pluralize(_.snakeCase(profile.name)),
              profile.id
            )
          "
          class="dropdown-item"
          href="#"
          >{{ profile.name }}</a
        >
      </base-dropdown>
      <base-dropdown v-else>
        <base-button slot="title" type="success" class="dropdown-toggle">
          Product Profiles
        </base-button>
        <a class="dropdown-item" disabled
          >No active module/s under this feature</a
        >
        <!-- <a v-for="profile in activeModules" :key="profile.id" @click.prevent="setCurrentProfile(_.pluralize(_.snakeCase(profile.name)))" class="dropdown-item" href="#">{{profile.name}}</a> -->
      </base-dropdown>
    </base-header>

    <div class="container-fluid mt--7">
      <div v-if="currentProfile == 'categories'" class="card mb-3">
        <a-spin :spinning="spinning">
          <div class="card shadow" style="min-height: 100%">
            <div
              class="card-header border-0"
              :class="type === 'dark' ? 'bg-transparent' : ''"
            >
              <div class="row align-items-center">
                <div class="col-md-12">Manage Categories</div>
                <div class="col-md-10">
                  <small>Set how products are sorted using nested groups</small>
                </div>
                <div class="col-md-2">
                  <base-dropdown
                    class="nav-link pr-0 float-right"
                    position="right"
                  >
                    <div class="media align-items-center" slot="title">
                      <i class="fa fa-ellipsis-v float-right btn-sm"></i>
                    </div>
                    <template>
                      <div class=" dropdown-header noti-title">
                        <h6 class="text-overflow m-0">ACTIONS</h6>
                      </div>
                      <div
                        v-if="accessRights.includes('E')"
                        class="dropdown-item"
                        @click.prevent="downloadCategories"
                      >
                        <i class="fa fa-download"></i>
                        <span>Export Categories</span>
                      </div>
                    </template>
                  </base-dropdown>
                </div>
                <div class="col-md-12"><br /></div>

                <!-- division -->
                <div
                  class="col-md-3 col-sm-6"
                  style="padding:0px; border-right: 1px #E9ECEF solid; height: 600px;"
                >
                  <ul class="list-group list-group-flush">
                    <li
                      class="list-group-item"
                      style="font-size: 14px; height: 55px; background-color: #f7f7f7;"
                    >
                      <div class="row">
                        <div class="col-md-8">MAIN CATEGORY</div>
                        <div
                          v-if="accessRights.includes('A')"
                          class="col-md-4 float-right"
                        >
                          <base-button
                            class="float-right ml-1"
                            type="primary"
                            size="sm"
                            @click.prevent="
                              showDrawer('addCategory', 'division', null)
                            "
                            ><span class="fa fa-plus" />
                          </base-button>
                        </div>
                      </div>
                    </li>

                    <div style="height: 545px; overflow-y: scroll;">
                      <li class="list-group-item" style="font-size: 14px;">
                        <span class="fa fa-lock" /> &nbsp; All Products
                      </li>
                      <li class="list-group-item" style="font-size: 14px">
                        <span class="fa fa-lock" /> &nbsp; Uncategorized
                      </li>
                      <li
                        class="list-group-item"
                        style="font-size: 14px"
                        v-for="division in divisionList"
                        :key="division.id"
                        :class="[{ selected2: divisionId == division.id }]"
                      >
                        <div class="row" @click="setDivision(division.id)">
                          <div class="col-md-8">
                            <a-dropdown>
                              <a class="ant-dropdown-link" href="#">
                                <span class="fa fa-ellipsis-v"></span>
                              </a>
                              <a-menu slot="overlay">
                                <a-menu-item
                                  v-if="accessRights.includes('W')"
                                  key="1"
                                  @click="
                                    showDrawer(
                                      'editCategory',
                                      'division',
                                      division
                                    )
                                  "
                                >
                                  Edit - {{ division.name }}
                                </a-menu-item>
                                <a-menu-item
                                  v-if="accessRights.includes('D')"
                                  key="2"
                                >
                                <!-- bryan -->
                                 <a-spin :spinning="spinner">
                                    <p  @click.prevent="checkBindedItems(division)" >Delete - {{ division.name }}</p>
                                 </a-spin>
                                </a-menu-item>
                              </a-menu>
                            </a-dropdown>
                            &nbsp;
                            {{ division.name }}
                          </div>
                          <div class="col-md-4">
                            <span
                              class="ni ni-bold-right float-right"
                              style="padding-bottom: 5px"
                            />
                          </div>
                        </div>
                      </li>
                    </div>
                  </ul>
                </div>

                <!-- department -->
                <div
                  class="col-md-3 col-sm-6"
                  style="padding:0px; border-right: 1px #E9ECEF solid; height: 600px;"
                >
                  <ul class="list-group list-group-flush" style="width: 100%;">
                    <li
                      class="list-group-item"
                      style="font-size: 14px; height: 55px; background-color: #f7f7f7"
                    >
                      <div class="row">
                        <div class="col-md-8">SUB CATEGORY</div>
                        <div class="col-md-4 float-right">
                          <base-button
                            v-if="accessRights.includes('A')"
                            class="float-right ml-1"
                            type="primary"
                            size="sm"
                            :disabled="divisionId == null"
                            @click.prevent="
                              showDrawer('addCategory', 'department', null)
                            "
                            ><span class="fa fa-plus" />
                          </base-button>
                        </div>
                      </div>
                    </li>
                    <div style="height: 545px; overflow-y: scroll;">
                      <li
                        class="list-group-item"
                        style="font-size: 14px"
                        v-for="department in departmentList"
                        :key="department.id"
                        :class="[{ selected2: departmentId == department.id }]"
                      >
                        <div class="row" @click="setDepartment(department.id)">
                          <div class="col-md-8">
                            <a-dropdown>
                              <a class="ant-dropdown-link" href="#">
                                <span class="fa fa-ellipsis-v"></span>
                              </a>
                              <a-menu slot="overlay">
                                <a-menu-item
                                  v-if="accessRights.includes('W')"
                                  key="1"
                                  @click="
                                    showDrawer(
                                      'editCategory',
                                      'department',
                                      department
                                    )
                                  "
                                >
                                  Edit - {{ department.name }}
                                </a-menu-item>
                                <a-menu-item
                                  v-if="accessRights.includes('D')"
                                  key="2"
                                >
                                  <!-- <a-popconfirm
                                    title="You are about to delete this record?"
                                    okText="Delete"
                                    cancelText="Cancel"
                                    @confirm="deleteData(department)"
                                  >
                                    Delete - {{ department.name }}
                                  </a-popconfirm> -->
                                     <!-- bryan -->
                                 <a-spin :spinning="spinner">
                                    <p  @click.prevent="checkBindedItems(department)" > Delete - {{ department.name }}</p>
                                 </a-spin>
                                </a-menu-item>
                              </a-menu>
                            </a-dropdown>
                            &nbsp;
                            {{ department.name }}
                          </div>
                          <div class="col-md-4">
                            <span
                              class="ni ni-bold-right float-right"
                              style="padding-bottom: 5px"
                            />
                          </div>
                        </div>
                      </li>
                    </div>
                  </ul>
                </div>

                <!-- section -->
                <div
                  class="col-md-3 col-sm-6"
                  style="padding:0px; border-right: 1px #E9ECEF solid; height: 600px;"
                >
                  <ul class="list-group list-group-flush" style="width: 100%;">
                    <li
                      class="list-group-item"
                      style="font-size: 14px; height: 55px; background-color: #f7f7f7"
                    >
                      <div class="row">
                        <div class="col-md-8">PRODUCT TYPE</div>
                        <div class="col-md-4 float-right">
                          <base-button
                            v-if="accessRights.includes('A')"
                            class="float-right ml-1"
                            type="primary"
                            size="sm"
                            :disabled="departmentId == null"
                            @click.prevent="
                              showDrawer('addCategory', 'section', null)
                            "
                          >
                            <span class="fa fa-plus" />
                          </base-button>
                        </div>
                      </div>
                    </li>
                    <div style="height: 545px; overflow-y: scroll;">
                      <li
                        class="list-group-item"
                        style="font-size: 14px"
                        v-for="section in sectionList"
                        :key="section.id"
                        :class="[{ selected2: sectionId == section.id }]"
                      >
                        <div class="row" @click="setSection(section.id)">
                          <div class="col-md-8">
                            <a-dropdown>
                              <a class="ant-dropdown-link" href="#">
                                <span class="fa fa-ellipsis-v"></span>
                              </a>
                              <a-menu slot="overlay">
                                <a-menu-item
                                  v-if="accessRights.includes('W')"
                                  key="1"
                                  @click="
                                    showDrawer(
                                      'editCategory',
                                      'section',
                                      section
                                    )
                                  "
                                >
                                  Edit - {{ section.name }}
                                </a-menu-item>
                                <a-menu-item
                                  v-if="accessRights.includes('D')"
                                  key="2"
                                >
                                  <!-- <a-popconfirm
                                    title="You are about to delete this record?"
                                    okText="Delete"
                                    cancelText="Cancel"
                                    @confirm="deleteData(section)"
                                  >
                                    Delete - {{ section.name }}
                                  </a-popconfirm> -->
                                     <!-- bryan -->
                                 <a-spin :spinning="spinner">
                                    <p  @click.prevent="checkBindedItems(section)" >Delete - {{ section.name }}</p>
                                 </a-spin>
                                </a-menu-item>
                              </a-menu>
                            </a-dropdown>
                            &nbsp;
                            {{ section.name }}
                          </div>
                          <div class="col-md-4">
                            <span
                              class="ni ni-bold-right float-right"
                              style="padding-bottom: 5px"
                            />
                          </div>
                        </div>
                      </li>
                    </div>
                  </ul>
                </div>

                <!-- class -->
                <div
                  class="col-md-3 col-sm-6"
                  style="padding:0px; border-right: 1px #E9ECEF solid; height: 600px;"
                >
                  <ul class="list-group list-group-flush" style="width: 100%;">
                    <li
                      class="list-group-item"
                      style="font-size: 14px; height: 55px; background-color: #f7f7f7"
                    >
                      <div class="row">
                        <div class="col-md-8">CLASS</div>
                        <div class="col-md-4 float-right">
                          <base-button
                            v-if="accessRights.includes('A')"
                            class="float-right ml-1"
                            type="primary"
                            size="sm"
                            :disabled="sectionId == null"
                            @click.prevent="
                              showDrawer('addCategory', 'class', null)
                            "
                          >
                            <span class="fa fa-plus" />
                          </base-button>
                        </div>
                      </div>
                    </li>
                    <div style="height: 545px; overflow-y: scroll;">
                      <li
                        class="list-group-item"
                        style="font-size: 14px"
                        v-for="class1 in classList"
                        :key="class1.id"
                        :class="[{ selected2: classId == class1.id }]"
                      >
                        <div class="row" @click="setClass(class1.id)">
                          <div class="col-md-12">
                            <a-dropdown>
                              <a class="ant-dropdown-link" href="#">
                                <span class="fa fa-ellipsis-v"></span>
                              </a>
                              <a-menu slot="overlay">
                                <a-menu-item
                                  v-if="accessRights.includes('W')"
                                  key="1"
                                  @click="
                                    showDrawer('editCategory', 'class', class1)
                                  "
                                >
                                  Edit - {{ class1.name }}
                                </a-menu-item>
                                <a-menu-item
                                  v-if="accessRights.includes('D')"
                                  key="2"
                                >
                                  <!-- <a-popconfirm
                                    title="You are about to delete this record?"
                                    okText="Delete"
                                    cancelText="Cancel"
                                    @confirm="deleteData(class1)"
                                  >
                                    Delete - {{ class1.name }}
                                  </a-popconfirm> -->
                                     <!-- bryan -->
                                 <a-spin :spinning="spinner">
                                    <p  @click.prevent="checkBindedItems(class1)" >Delete - {{ class1.name }}</p>
                                 </a-spin>
                                </a-menu-item>
                              </a-menu>
                            </a-dropdown>
                            &nbsp;
                            {{ class1.name }}
                          </div>
                        </div>
                      </li>
                    </div>
                  </ul>
                </div>

              <a-modal 
                :visible="showModal" 
                :title="bindedItems !== 0? 'Cannot delete attribute' : 'You are about to delete this record?'" 
                :okButtonProps="bindedItems !== 0 && { style: { display: 'none'} }"
                cancelText="Close"
                okText="Proceed"
                @ok="deleteData(currentSelectedItem)" 
                @cancel="closeModal"
                :closable="false"
                >
                <p v-if="bindedItems!== 0">
                  There are {{ bindedItems }} item/s currently using this attribute. <br>
                </p>
                <p v-else>
                  Would you like to continue ?
                </p>
              </a-modal>
              </div>
            </div>
          </div>
        </a-spin>
      </div>

      <div v-else class="row">
        <div class="col">
          <div class="card mb-3">
            <div v-if="currentProfile == 'size_groups'" class="row no-gutters">
              <div class="col-md-3" style="border-right: 1px solid #e0e0e0">
                <div class="card-body">
                  <filter-bar @changeFilter="changeFilter"></filter-bar>
                </div>
              </div>

              <div class="col-md-9" style="overflow: scroll;">
                <div class="row no-gutters" style="min-height: 100%">
                  <div
                    class="col-md-12"
                    style="border-right: 1px solid #e0e0e0;"
                  >
                    <profiles-table
                      :status="filterStatus"
                      :key="formKey"
                      :accessRights="accessRights"
                      @selectName="(name) => this.selectedName = name"
                    ></profiles-table>
                  </div>

                  <div class="col-md-12">
                    <hr />
                    <small v-if="parentId === 0" class="ml-2">
                      <span class="fa fa-info-circle" /> Please select a size group.
                    </small>
                    <size-group
                      :key="formKey2"
                      :accessRights="accessRights"
                      :name="this.selectedName"
                    ></size-group>
                  </div>
                </div>
              </div>
            </div>

            <!-- Brand | brand and sub-brand | Sub Brand -->
            <div v-else-if="currentProfile == 'brands'" class="row no-gutters">
              <div class="col-md-3" style="border-right: 1px solid #e0e0e0">
                <div class="card-body">
                  <filter-bar @changeFilter="changeFilter"></filter-bar>
                </div>
              </div>

              <div class="col-md-9" style="overflow: scroll;">
                <div class="row no-gutters" style="min-height: 100%">
                  <div
                    class="col-md-12"
                    style="border-right: 1px solid #e0e0e0;"
                  >
                    <profiles-table
                      :status="filterStatus"
                      :key="formKey"
                      :accessRights="accessRights"
                    ></profiles-table>
                  </div>

                  <!-- SubBrand | sub brand | sub-brand -->
                  <div class="col-md-12">
                    <hr />
                    <small class="ml-2">
                      <span class="fa fa-info-circle" /> Please select a brand.
                    </small>
                    <sub-brand
                      :key="formKey"
                      :accessRights="accessRights"
                    ></sub-brand>
                  </div>
                  <!-- end SubBrand | sub brand | sub-brand -->
                </div>
              </div>
            </div>
            <!-- end Brand | brand and sub-brand | Sub Brand -->

            <!-- Color | color and color family | Color Family -->
            <div v-else-if="currentProfile == 'colors'" class="row no-gutters">
              <div class="col-md-3" style="border-right: 1px solid #e0e0e0">
                <div class="card-body">
                  <filter-bar @changeFilter="changeFilter"></filter-bar>
                </div>
              </div>

              <div class="col-md-9" style="overflow: scroll;">
                <div class="row no-gutters" style="min-height: 100%">
                  <div
                    class="col-md-12"
                    style="border-right: 1px solid #e0e0e0;"
                  >
                    <profiles-table
                      :status="filterStatus"
                      :key="formKey"
                      :accessRights="accessRights"
                      @selectName="(name) => this.selectedName = name"
                    ></profiles-table>
                  </div>

                  <div class="col-md-12">
                    <hr />
                    <small v-if="parentId === 0" class="ml-2">
                      <span class="fa fa-info-circle" /> Please select a color.
                    </small>
                    <color-family
                      :key="formKey3"
                      :accessRights="accessRights"
                      :name="this.selectedName"
                    ></color-family>
                  </div>
                </div>
              </div>
            </div>
            <!-- end Color | color and color family | Color Family -->

            <div v-else class="row no-gutters">
              <div class="col-md-3" style="border-right: 1px solid #e0e0e0">
                <div class="card-body">
                  <filter-bar
                    @changeFilter="changeFilter"
                    :key="statusKey"
                  ></filter-bar>
                </div>
              </div>

              <div class="col-md-9">
                <div class="card-body">
                  <profiles-table
                    :status="filterStatus"
                    :key="formKey"
                    :accessRights="accessRights"
                  ></profiles-table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import secureStorage from "../../controllers/secureStorage.js";
import HTTPRequest from "../../controllers/httpRequest.js";
import ProfilesTable from "../Tables/ProductProfilesTable.vue";
import SizeGroup from "../Product Profiles V2/SizeGroup.vue";
import SubBrand from "../Product Profiles V2/SubBrand.vue"; // sub brand component
import ColorFamily from "../Product Profiles V2/ColorFamily.vue"; // sub brand component
import FilterBar from "./../FilterBar";
import DynamicForm from "../DynamicForm.vue";
import { mapState, mapActions } from "vuex";

var ObjGen = require("../../../node_modules/objgen/objgen.js").ObjGen;

let  component_x;

export default {
  data: function() {
    return {
      filterStatus: "",
      categoryName: "",
      categoryCode: "",
      categoryRefCode: "",
      categoryRemark: "",
      spinning: false,
      activeModules: [],
      formKey: 0,
      divisionList: [],
      divisionId: null,
      departmentList: [],
      departmentId: null,
      sectionList: [],
      sectionId: null,
      classList: [],
      classId: null,
      formId: null,
      visible: false,
      type: null,
      jsonField: null,
      convertedJson: null,
      formSettings: {},
      componentKey: 0,
      accessRights: [],
      formKey2: 0,
      formKey3: 0,
      errors: [],
      statusKey: 0,
      selectedName: "",
      // bryan START
      spinner:false,
      showModal:false,
      bindedItems: 0,
      currentSelectedItem: null
      // bryan END
    };
  },
  mounted: async function() {
    component_x = this;
    this.spinning = true;
    var categoryId = await HTTPRequest.getRequest(
      this.endPoint + "/system_module_categories?code=MCS-001",
      null,
      null
    );
    this.activeModules = await HTTPRequest.getRequest(
      this.endPoint +
        "/system_module_categories/" +
        categoryId[0].id +
        "/enabled_modules",
      null,
      null
    );
    if (this.activeModules.length > 0) {
      var profile = _.snakeCase(this.activeModules[0].name);
      this.setCurrentProfile(_.pluralize(profile), this.activeModules[0].id);
    } else {
      this.setCurrentProfile(null, null);
      this.formKey++;
    }
    this.spinning = false;
  },
  computed: {
    ...mapState([
      "currentProfile",
      "currentApiURL",
      "endPoint",
      "parameters",
      "parentId",
      "serverType",
    ]),
  },
  components: {
    ProfilesTable,
    FilterBar,
    SizeGroup,
    DynamicForm,
    SubBrand,
    ColorFamily,
  },
  methods: {
    ...mapActions([
      "updateCurrentProfile",
      "updateParameters",
      "updateParentId",
    ]),
    // bryan START
    async checkBindedItems(parameter){
      this.spinner = true
      // this.selectedKey = parameter.id;
      // this.categoryLevel = parameter.level;
        // bryan
      //  if(parameter.level === 1){
      //   // console.log(this.endPoint + "categories?level=1")
      //   console.log(parameter.id)
      //  }else if(parameter.level === 2 || parameter.level === 3){
      //   // console.log(this.endPoint + "categories?parent_category_id=" + parameter.id,)
      //   console.log(parameter.id)
      //  }else{
      //   // console.log(this.endPoint + "categories?per_page=500&parent_category_id=" + parameter.id)
      //   console.log(parameter.id)
      //  }
        
      await axios({
        method: "get",
        url: this.endPoint + this.currentProfile + "/check_binded_items?id=" + parameter.id,
        headers: {
          Authorization: "Bearer " + secureStorage.getItem("accessToken"),
          "Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-Web", 'ip':secureStorage.getItem("ipAddress")
        },
      }).then(function (resp) {
          component_x.spinner = false
          component_x.bindedItems = resp.data.length
          component_x.showModal = true
          component_x.currentSelectedItem = parameter
        })
        .catch(function () {
          alert("Invalid Credentials");
          component_x.spinner = false
        });
        this.showModal = true
    },
    closeModal(){
      this.showModal = !this.showModal
    },
    // bryan END
    updateSettings(formSettings, settingsGrouping) {
      this.formSettings = formSettings; 
    },
    async setCurrentProfile(profile, id) {
      this.spinning = true;
      this.profileId = id;
      var accessRightsRequest = await HTTPRequest.getRequest(
        this.endPoint +
          "users/" +
          secureStorage.getItem("userId") +
          "/access_rights?system_module_id=" +
          id,
        null
      );
      if (_.isEmpty(accessRightsRequest.access_rights) == false) {
        this.accessRights = accessRightsRequest.access_rights[id];
      } else {
        this.accessRights = [];
      }
      this.updateCurrentProfile(profile);
      if (profile == "size_groups") this.formKey2++;
      if (profile == "colors") this.formKey3++;
      this.formKey++;

      if (profile == "categories") {
        // alert("Do something.")
        var division = await HTTPRequest.getRequest(
          this.endPoint + "/categories?level=1",
          null
        );
        this.divisionList = division;
        this.divisionId = null;
        this.departmentList = [];
        this.departmentId = null;
        this.sectionList = [];
        this.sectionId = null;
        this.classList = [];
        this.classId = null;
      } else {
        this.setParentId(0);
      }
      this.spinning = false;
      this.statusKey++;
    },
    async setDivision(divisionId) {
      this.spinning = true;
      this.divisionId = divisionId;
      var departments = await HTTPRequest.getRequest(
        this.endPoint + "/categories?parent_category_id=" + this.divisionId,
        null
      );
      this.departmentList = departments;
      this.departmentId = null;
      this.sectionList = [];
      this.sectionId = null;
      this.classList = [];
      this.classId = null;
      this.spinning = false;
    },
    async setDepartment(departmentId) {
      this.spinning = true;
      this.departmentId = departmentId;
      var sections = await HTTPRequest.getRequest(
        this.endPoint + "/categories?parent_category_id=" + this.departmentId,
        null
      );
      this.sectionList = sections;
      this.sectionId = null;
      this.classList = [];
      this.classId = null;
      this.spinning = false;
    },
    async setSection(sectionId) {
      this.spinning = true;
      this.sectionId = sectionId;
      var classes = await HTTPRequest.getRequest(
        this.endPoint +
          "/categories?per_page=500&parent_category_id=" +
          this.sectionId,
        null
      );
      this.classList = classes;
      this.classId = null;
      this.spinning = false;
    },
    async setClass(classId) {
      this.classId = classId;
      //   var classes = await HTTPRequest.getRequest(this.endPoint + "/categories?parent_category_id=" + this.sectionId, null)
      //   this.classList = classes.data
    },
    async showDrawer(type, mode, category) {
      this.formId = type;
      this.visible = true;
      var jsonField;
      if (type == "addCategory") {
        this.clearData();
        switch (mode) {
          case "division":
            // this.selectedKey = -1
            this.selectedKey = 0;
            this.categoryLevel = 1;
            break;
          case "department":
            this.selectedKey = this.divisionId;
            this.categoryLevel = 2;
            break;
          case "section":
            this.selectedKey = this.departmentId;
            this.categoryLevel = 3;
            break;
          case "class":
            this.selectedKey = this.sectionId;
            this.categoryLevel = 4;
            break;
        }
        this.categoryName = "New Level " + this.categoryLevel.toString();
        if (this.categoryLevel == 4) {
          jsonField = await HTTPRequest.getRequest(
            this.endPoint +
              "dynamic_forms/Product Category?field_name=profile_name",
            null,
            null
          );
          this.convertedJson = ObjGen.xJson(jsonField.template, {
            numSpaces: 2,
          });
        }
      }

      if (type == "editCategory") {
        switch (mode) {
          case "division":
            this.categoryLevel = 1;
            break;
          case "department":
            this.categoryLevel = 2;
            break;
          case "section":
            this.categoryLevel = 3;
            break;
          case "class":
            this.categoryLevel = 4;
            break;
        }
        this.selectedKey = category.id;
        this.categoryName = category.name;
        this.categoryCode = category.code;
        this.categoryRefCode = category.refcode;
        this.categoryRemark = category.remark;

        if (this.categoryLevel == 4) {
          jsonField = await HTTPRequest.getRequest(
            this.endPoint +
              "dynamic_forms/Product Category?field_name=profile_name",
            null,
            null
          );
          this.convertedJson = ObjGen.xJson(jsonField.template, {
            numSpaces: 2,
          });

          var formSettings = await HTTPRequest.getRequest(
            this.endPoint + "categories/" + category.id + "/get_settings",
            null,
            null
          );
          this.formSettings = JSON.parse(formSettings["settings"]);
          this.componentKey++;
        }
      }

      if (this.serverType == "branch") {
        var form = document.getElementById("form-proper");
        var elements = form.elements;
        for (var i = 0, len = elements.length; i < len; ++i) {
          elements[i].readOnly = true;
        }
      }
    },
    // DRAWER FUNCTIONS
    onClose() {
      this.visible = false;
      this.componentKey++;
      this.formSettings = {};
    },
    async createData() {
      var categoryPayload = {
        category: {
          name: this.categoryName.trim(),
          code: this.categoryCode.trim(),
          refcode: this.categoryRefCode.trim(),
          status: "A",
          parent_category_id: this.selectedKey,
          remark: this.categoryRemark,
          category_settings: JSON.stringify(this.formSettings),
        },
      };
      var post_request = await HTTPRequest.postRequest(
        this.endPoint + "categories",
        null,
        categoryPayload
      );
      let success = false;
      if (post_request == undefined) {
        success = true;
        alert("Create Successful");
      } else {
        if (post_request["error"] == undefined) {
          success = true;
          alert("Create Successful");
        } else {
          success = false;
          this.errors = post_request["error"].split(",");
        }
      }

      if (success == true) {
        switch (this.categoryLevel) {
          case 1:
            var division = await HTTPRequest.getRequest(
              this.endPoint + "/categories?level=1",
              null
            );
            this.divisionList = division;
            break;
          case 2:
            this.setDivision(this.divisionId);
            break;
          case 3:
            this.setDepartment(this.departmentId);
            break;
          case 4:
            this.setSection(this.sectionId);
            break;
        }
        this.clearData();
        this.onClose();
      }
    },
    async deleteData(category) {
      this.showModal = false
      this.selectedKey = category.id;
      this.categoryLevel = category.level;
      if (category.with_children) {
        alert("You cannot delete a parent category.");
      } else {
        var categoryPayload = { category: { status: "D" } };
        await HTTPRequest.destroyRequest(
          this.endPoint + "categories/" + this.selectedKey,
          null,
          categoryPayload
        );
        switch (this.categoryLevel) {
          case 1:
            var division = await HTTPRequest.getRequest(
              this.endPoint + "/categories?level=1",
              null
            );
            this.divisionList = division;
            break;
          case 2:
            this.setDivision(this.divisionId);
            break;
          case 3:
            this.setDepartment(this.departmentId);
            break;
          case 4:
            this.setSection(this.sectionId);
            break;
        }
        this.clearData();
        alert("Delete Successful");
      }
    },
    async updateData() {
      var categoryPayload = {
        category: {
          name: this.categoryName.trim(),
          code: this.categoryCode.trim(),
          refcode: this.categoryRefCode.trim(),
          status: "A",
          remark: this.categoryRemark,
          category_settings: JSON.stringify(this.formSettings),
        },
      };
      var put_request = await HTTPRequest.putRequest(
        this.endPoint + "categories/" + this.selectedKey,
        null,
        categoryPayload
      );
      let success = false;
      if (put_request == undefined) {
        success = true;
        alert("Update Successful");
      } else {
        if (put_request["error"] == undefined) {
          success = true;
          alert("Update Successful");
        } else {
          success = false;
          this.errors = put_request["error"].split(",");
        }
      }

      if (success == true) {
        switch (this.categoryLevel) {
          case 1:
            var division = await HTTPRequest.getRequest(
              this.endPoint + "/categories?level=1",
              null
            );
            this.divisionList = division;
            break;
          case 2:
            this.setDivision(this.divisionId);
            break;
          case 3:
            this.setDepartment(this.departmentId);
            break;
          case 4:
            this.setSection(this.sectionId);
            break;
        }
        this.clearData();
        this.onClose();
      }
    },
    async downloadCategories() {
      axios({
        url: this.endPoint + "/categories/download?type=bxi",
        method: "POST",
        responseType: "blob", // important
        headers: {
          Authorization: "Bearer " + secureStorage.getItem("accessToken"),
          "Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-File", 'ip':secureStorage.getItem("ipAddress")
        },
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "categories.csv");
        document.body.appendChild(link);
        link.click();
        this.successMessage = "Download successful";
      });
    },
    clearData() {
      this.categoryName = null;
      this.categoryCode = "";
      this.categoryRefCode = "";
      this.categoryRemark = null;
      this.formSettings = {};
      this.componentKey++;
      this.errors = [];
    },
    setParentId(id) {
      this.updateParentId(id);
    },
    changeFilter(statusFilter, searchFilter, searchText) {
      this.setParentId(0);
      this.filterStatus = statusFilter;
      if (statusFilter == "0") {
        this.updateParameters("?" + searchFilter + "=" + searchText);
      } else if (statusFilter == "A") {
        this.updateParameters(
          "?" + searchFilter + "=" + searchText + "&status=A"
        );
      } else {
        this.updateParameters(
          "?" + searchFilter + "=" + searchText + "&status=I"
        );
      }
      this.formKey2++;
      this.formKey3++;
    },
  },
};
</script>

<style>
.selected2 {
  background-color: #eff6ff;
  color: #2371cc;
}
</style>
